import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"; // WhatsApp icon from Font Awesome

const WhatsaapChannel: React.FC = () => {
  const link = "https://whatsapp.com/channel/0029VaxLi5yEwEjsRlgfSq04";

  return (
    <>
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: "none", // Remove underline
        backgroundColor: "#25D366", // WhatsApp green color
        color: "white", // Text color
        padding: "8px 15px", // Small padding for compact button
        borderRadius: "5px", // Rounded corners
        display: "inline-flex", // Keep it inline with other elements
        alignItems: "center", // Align icon and text vertically
        justifyContent: "center",
        fontSize: "14px", // Small font size
        fontWeight: "500", // Normal weight text
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", // Subtle shadow
        cursor: "pointer", // Pointer cursor
        margin: "0", // No margin to avoid pushing other elements
       
      }}
      title="Contact us on WhatsApp"
    >
      {/* Font Awesome WhatsApp Icon */}
      <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: "8px", fontSize: "16px" }} />
      {/* Text inside button */}
      <span>Join Whatsapp Channel for updates</span>





      
    </a>
    </>
  );
};

export default WhatsaapChannel;
